import type { SetCopy } from '../catalog'

// Album covers rebuilt as tile mosaics on 48 or 64-stud baseplates in a
// black frame, in release order. The mosaics are baked by scripts/bricks/bake-mosaics.ts;
// see models/rotation/.
export const ROTATION: SetCopy[] = [
  {
    slug: 'graduation',
    series: 'rotation',
    number: 1,
    name: 'Graduation',
    maker: 'Kanye West',
    year: 2007,
    tagline: 'Dropout Bear, launched into a purple sky.',
    story:
      "Kanye West's 2007 stadium record, dressed by Takashi Murakami. The mosaic raises the bear a plate off a purple sky, over the Superflat colour riot in the corner below.",
    age: '12+',
    mosaic: true,
    palette: {
      cover: '#8E5CA8',
      flood: '#5B2E7A',
      ink: '#FFFFFF',
      ground: '#F1E8F6',
      accent: '#E4ADC8',
    },
    aliases: ['graduation', 'dropout bear', 'stronger', 'murakami'],
  },
  {
    slug: 'my-beautiful-dark-twisted-fantasy',
    series: 'rotation',
    number: 2,
    name: 'My Beautiful Dark Twisted Fantasy',
    maker: 'Kanye West',
    year: 2010,
    tagline: 'The censored cover, already half a mosaic.',
    story:
      "Kanye West's maximalist 2010 record, made during a self-imposed exile in Hawaii. The retail cover pixelated George Condo's painting into a square on red, so this set is a mosaic of a mosaic: two studs for every block of the square, in a gold frame hung a plate proud of the red.",
    age: '12+',
    mosaic: true,
    palette: {
      cover: '#C91A09',
      flood: '#8E1208',
      ink: '#FFFFFF',
      ground: '#F6E3DF',
      accent: '#E0A15C',
    },
    aliases: ['mbdtf', 'kanye', 'runaway', 'power', 'all of the lights'],
  },

  {
    slug: 'blonde',
    series: 'rotation',
    number: 3,
    name: 'Blonde',
    maker: 'Frank Ocean',
    year: 2016,
    tagline: 'The white frame and a hand over the face.',
    story:
      "Frank Ocean's second album came out on his own terms in 2016, after years of waiting. The mosaic keeps what you'd recognise across a room: the bold black wordmark, the white border, and the grey-tiled photo raised like a print, with a hand held up to the face.",
    age: '12+',
    mosaic: true,
    palette: {
      cover: '#F2F2F2',
      flood: '#6C6E68',
      ink: '#FFFFFF',
      ground: '#EDEDED',
      accent: '#4B9F4A',
    },
    aliases: [
      'blond',
      'frank ocean',
      'nikes',
      'ivy',
      'pink + white',
      'self control',
    ],
  },
  {
    slug: 'awaken-my-love',
    series: 'rotation',
    number: 4,
    name: '"Awaken, My Love!"',
    maker: 'Childish Gambino',
    year: 2016,
    tagline: 'A beaded headdress glowing out of the dark.',
    story:
      'Donald Glover\'s turn to psychedelic soul and funk, home of "Redbone". Out of the dark blue field, a ring of pale azure tiles traces the beaded headdress around a face.',
    age: '12+',
    mosaic: true,
    palette: {
      cover: '#0A3463',
      flood: '#0A2240',
      ink: '#FFFFFF',
      ground: '#DCE8F4',
      accent: '#36AEBF',
    },
    aliases: [
      'awaken my love',
      'childish gambino',
      'donald glover',
      'redbone',
      'funk',
    ],
  },

  {
    slug: 'damn',
    series: 'rotation',
    number: 5,
    name: 'DAMN.',
    maker: 'Kendrick Lamar',
    year: 2017,
    tagline: 'Red capitals over a brick wall.',
    story:
      "Kendrick Lamar's Pulitzer Prize-winning album from 2017. The set keeps the loud parts of Vlad Sepetov's cover: DAMN. in red across the top, the brick wall, and the white T-shirt.",
    age: '12+',
    mosaic: true,
    palette: {
      cover: '#F4F4F4',
      flood: '#720E0F',
      ink: '#FFFFFF',
      ground: '#F3E7E4',
      accent: '#C91A09',
    },
    aliases: ['damn', 'kendrick', 'kendrick lamar', 'humble', 'dna'],
  },
  {
    slug: 'flower-boy',
    series: 'rotation',
    number: 6,
    name: 'Flower Boy',
    maker: 'Tyler, The Creator',
    year: 2017,
    tagline: 'Sunflowers, a sunset and a bee over the face.',
    story:
      "Tyler, The Creator's 2017 turn to soft jazz chords and neo-soul. Eric White's painted cover, a sunflower field under an orange sunset, becomes bands of orange and red sky, green hills and a front row of sunflower tiles, with Tyler in the middle.",
    age: '12+',
    mosaic: true,
    palette: {
      cover: '#FE8A18',
      flood: '#C8501A',
      ink: '#1B1B1B',
      ground: '#FFF1E2',
      accent: '#F2CD37',
    },
    aliases: ['flower boy', 'see you again', 'sunflowers'],
  },
  {
    slug: 'astroworld',
    series: 'rotation',
    number: 7,
    name: 'ASTROWORLD',
    maker: 'Travis Scott',
    year: 2018,
    tagline: 'A golden head as the gates of a theme park.',
    story:
      "Travis Scott's 2018 album is named after the Houston theme park torn down in 2005. David LaChapelle's cover, a giant golden inflatable of Scott's head under a blue sky, becomes sky blues over a gold-and-tan head.",
    age: '12+',
    mosaic: true,
    palette: {
      cover: '#9FC3E9',
      flood: '#5A7FA8',
      ink: '#1B1B1B',
      ground: '#EAF2FB',
      accent: '#F8BB3D',
    },
    aliases: [
      'astroworld',
      'travis scott',
      'sicko mode',
      'cactus jack',
      'la flame',
    ],
  },
  {
    slug: 'swimming',
    series: 'rotation',
    number: 8,
    name: 'Swimming',
    maker: 'Mac Miller',
    year: 2018,
    tagline: 'A dark doorway on a white page.',
    story:
      "Mac Miller's fifth album and the last released in his lifetime, from 2018. The mosaic is mostly white, with the tall dark box standing out of it, a round porthole, and Mac in his pink suit at its foot.",
    age: '12+',
    mosaic: true,
    palette: {
      cover: '#FFFFFF',
      flood: '#1B2A34',
      ink: '#FFFFFF',
      ground: '#F4F4F4',
      accent: '#E4ADC8',
    },
    aliases: ['swimming', 'mac miller', 'self care', 'small worlds'],
  },
  {
    slug: 'igor',
    series: 'rotation',
    number: 9,
    name: 'IGOR',
    maker: 'Tyler, The Creator',
    year: 2019,
    tagline: 'Flat pink, one grey face.',
    story:
      'Tyler, The Creator wrote, produced and arranged all of his 2019 album himself. The cover is about as bold as album art gets: flat pink behind a grey portrait. It builds from long pink tiles around greys and black.',
    age: '12+',
    mosaic: true,
    palette: {
      cover: '#E4ADC8',
      flood: '#C9829F',
      ink: '#1B1B1B',
      ground: '#FBEFF4',
      accent: '#6C6E68',
    },
    aliases: [
      'igor',
      'tyler',
      'tyler the creator',
      'earfquake',
      'a boy is a gun',
    ],
  },
  {
    slug: 'sos',
    series: 'rotation',
    number: 10,
    name: 'SOS',
    maker: 'SZA',
    year: 2022,
    tagline: 'One figure on a diving board, far out at sea.',
    story:
      "SZA's 2022 album restages a famous 1997 photo of Princess Diana on a yacht. The set is open sea, lighter toward the horizon, with a single diving board running in from the edge.",
    age: '12+',
    mosaic: true,
    palette: {
      cover: '#0A3463',
      flood: '#06203E',
      ink: '#FFFFFF',
      ground: '#E3EAF3',
      accent: '#6074A1',
    },
    aliases: ['sos', 'sza', 'kill bill', 'snooze'],
  },
]
